<script>
/* eslint-disable max-len */
export default {
  name: 'ThreeVerticalDots',
};
</script>
<template>
  <svg
    width="10"
    viewBox="0 0 10 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.34615 66.4999C7.64026 66.4999 9.5 68.3597 9.5 70.6538C9.5 72.9479 7.64026 74.8076 5.34615 74.8076C3.05205 74.8076 0.5 72.9479 0.5 70.6538C0.5 68.3597 3.05205 66.4999 5.34615 66.4999Z"
      fill="#030301"
      fill-opacity="0.9"
    />
    <path
      d="M5 41.5C2.51472 41.5 0.5 39.4853 0.5 37C0.5 34.5147 2.51472 34 5 34C7.48528 34 9.5 34.5147 9.5 37C9.5 39.4853 7.48528 41.5 5 41.5Z"
      fill="#030301"
      fill-opacity="0.9"
    />
    <circle
      cx="5"
      cy="4.5"
      r="4.5"
      transform="rotate(-90 5 4.5)"
      fill="#030301"
      fill-opacity="0.9"
    />
  </svg>
</template>
